import { useEffect } from 'react';
import { useRoutes } from 'react-router';
import { Toaster } from 'react-hot-toast';
import { CssBaseline, ThemeProvider } from '@mui/material';
import moment from 'moment';
import './i18n';

moment.updateLocale('ja', {
	months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	relativeTime: {
		future: '%s後',
		past: '%s前',
		s: '数秒',
		ss: '%d秒',
		m: '1分',
		mm: '%d分',
		h: '1時間',
		hh: '%d時間',
		d: '1日',
		dd: '%d日',
		M: '1ヶ月',
		MM: '%dヶ月',
		y: '1年',
		yy: '%d年',
	},
});
moment.locale('ja');
import RTL from './components/RTL';
import SplashScreen from './components/SplashScreen';
import { gtmConfig } from './config';
import useAuth from './hooks/useAuth';
import useScrollReset from './hooks/useScrollReset';
import useSettings from './hooks/useSettings';
import gtm from './lib/gtm';
import routes from './routes';
import { createCustomTheme } from './theme';

const App = () => {
	const content = useRoutes(routes);
	const { settings } = useSettings();
	const auth = useAuth();

	useScrollReset();

	useEffect(() => {
		gtm.initialize(gtmConfig);
	}, []);

	const theme = createCustomTheme({
		direction: settings.direction,
		responsiveFontSizes: settings.responsiveFontSizes,
		roundedCorners: settings.roundedCorners,
		theme: settings.theme,
	});

	return (
		<ThemeProvider theme={theme}>
			<RTL direction={settings.direction}>
				<CssBaseline />
				<Toaster position="top-center" />
				{auth.isInitialized ? content : <SplashScreen />}
			</RTL>
		</ThemeProvider>
	);
};

export default App;
